import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import 'react-input-range/lib/css/index.css'
import BrowserNotification from 'react-web-notification/lib/components/Notification'

class Notification extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      ignore: true,
    }
  }

  handlePermissionGranted() {
    console.log('Permission Granted')
    this.setState({
      ignore: false,
    })
  }
  handlePermissionDenied() {
    console.log('Permission Denied')
    this.setState({
      ignore: true,
    })
  }
  handleNotSupported() {
    console.log('Web Notification not Supported')
    this.setState({
      ignore: true,
    })
  }

  render() {
    const { title, options, onShow, onClick, timeout } = this.props

    return (
      <BrowserNotification
        ignore={this.state.ignore && this.state.title !== ''}
        notSupported={this.handleNotSupported.bind(this)}
        onPermissionGranted={this.handlePermissionGranted.bind(this)}
        onPermissionDenied={this.handlePermissionDenied.bind(this)}
        onShow={onShow}
        onClick={onClick}
        // onClose={this.handleNotificationOnClose.bind(this)}
        // onError={this.handleNotificationOnError.bind(this)}
        timeout={timeout}
        title={title}
        options={options}
      />
    )
  }
}

Notification.defaultProps = {
  timeout: 5000,
}
Notification.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.object,
  onShow: PropTypes.func,
  onClick: PropTypes.func,
  timeout: PropTypes.number,
}

export default Notification
